export const REFUTATION_WAIT_VALUES_MS = [250, 500, 750, 1000] as const;

export type RefutationWaitMs = (typeof REFUTATION_WAIT_VALUES_MS)[number];

export const DEFAULT_REFUTATION_WAIT_MS: RefutationWaitMs = 1000;

const STORAGE_KEY = 'endchess.refutation.waitMs';

export const normalizeRefutationWaitMs = (
  value: unknown,
): RefutationWaitMs => {
  const parsed =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
        ? Number(value)
        : Number.NaN;
  return REFUTATION_WAIT_VALUES_MS.includes(parsed as RefutationWaitMs)
    ? (parsed as RefutationWaitMs)
    : DEFAULT_REFUTATION_WAIT_MS;
};

export const readRefutationWaitMs = (): RefutationWaitMs => {
  try {
    return normalizeRefutationWaitMs(localStorage.getItem(STORAGE_KEY));
  } catch {
    return DEFAULT_REFUTATION_WAIT_MS;
  }
};

export const writeRefutationWaitMs = (value: RefutationWaitMs): void => {
  try {
    localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    // Ignore storage failures; the current page still keeps its selected value.
  }
};
